import { Component, input, signal, OnInit } from '@angular/core';

@Component({
  selector: 'oes-collapsible-section',
  templateUrl: './collapsible-section.component.html',
  styleUrls: ['./collapsible-section.component.scss']
})
export class CollapsibleSectionComponent implements OnInit {
  title = input.required<string>();
  isExpanded = input<boolean>(false);
  icon = input<string>('');

  expanded = signal(false);

  ngOnInit() {
    this.expanded.set(this.isExpanded());
  }

  toggleExpand() {
    this.expanded.set(!this.expanded());
  }
}
